import React from 'react';

const ITServicesContact = () => {
  return (
    <main style={{ padding: 40, minHeight: '60vh' }}>
      <h1>AILYT IT Services — Contact</h1>
      <p>Get in touch with us for project enquiries and consultations.</p>
    </main>
  );
};

export default ITServicesContact;
